const widgetIsFullWidth = (embeddedWidget) => {
  const {
    presentation: {
      size,
    },
    widget: {
      name,
    },
  } = embeddedWidget;

  const smallWidgetTypes = {
    nbc_liftout: ['small'],
    nbc_pullquote: ['small'],
    nbc_pull_quote: ['small'],
    advanced_embed: ['small', 'medium'],
    CUSTOM_EMBED: ['small', 'medium'],
  };

  if (smallWidgetTypes[name] && !smallWidgetTypes[name].includes(size)) {
    return true;
  }

  return false;
};

const imageIsFullWidth = (embeddedImage) => {
  const { presentation: { size }, ecommerceEnabled } = embeddedImage;
  const isNotSmall = size !== 'small' && size !== 'medium';
  if (isNotSmall && !ecommerceEnabled) {
    return true;
  }

  return false;
};

const productIsFullWidth = (embeddedProduct, amp) => {
  const {
    presentation: {
      size,
    },
  } = embeddedProduct;


  if (size === 'large' && !amp) return true;

  return false;
};

export function isFullWidth(item, amp) {
  const { type } = item;

  switch (type) {
    case 'embeddedWidget':
      return widgetIsFullWidth(item);
    case 'embeddedImage':
      return imageIsFullWidth(item);
    case 'embeddedVideo':
      return false;
    case 'embeddedProduct':
      return productIsFullWidth(item, amp);
    case 'embeddedProductList':
      return true;
    default:
      return false;
  }
}
